import { rcaptureEntry } from './rcapture-entry.js';
/**
 * Route matcher that matches any route entry.
 */
export const rmatchEntry = /*#__PURE__*/ rcaptureEntry();
//# sourceMappingURL=rmatch-entry.js.map